module.exports = __webpack_public_path__ + "static/media/pdf_multi_header.0457a7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf_multi_header.png
// module id = 458
// module chunks = 0